(() => {
	if (window.DifraxBannerWithTextLoaded) return;

	window.DifraxBannerWithTextLoaded = true;

	const animationSelector = ".banner-with-text[data-scroll-animation]";
	const prefersReducedMotion = () =>
		window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const isDesktop = () => window.matchMedia("(min-width: 750px)").matches;
	const videoSelector = "[data-banner-with-text-video]";

	const loadVideo = (video) => {
		if (video.dataset.deferredVideoLoaded === "true") return;

		video.querySelectorAll("source[data-src]").forEach((source) => {
			source.src = source.dataset.src;
			source.removeAttribute("data-src");
		});
		video.dataset.deferredVideoLoaded = "true";
		video.load();
	};

	const playVideo = async (video, playButton) => {
		loadVideo(video);

		try {
			await video.play();
			if (playButton) playButton.hidden = true;
		} catch (error) {
			if (playButton) playButton.hidden = false;
		}
	};

	const initBannerVideo = (shell) => {
		if (shell.dataset.bannerVideoInitialized === "true") return;
		shell.dataset.bannerVideoInitialized = "true";

		const videos = [...shell.querySelectorAll("[data-deferred-video]")];
		let isNearViewport = false;

		const activeVideo = () =>
			videos.find(
				(video) =>
					window.getComputedStyle(video.parentElement).display !== "none",
			);

		const revealActiveControl = () => {
			videos.forEach((video) => {
				const button = video.parentElement.querySelector(
					"[data-deferred-video-play]",
				);
				if (button) button.hidden = video !== activeVideo();
			});
		};

		const activate = () => {
			const video = activeVideo();
			if (!video) return;

			const button = video.parentElement.querySelector(
				"[data-deferred-video-play]",
			);
			const shouldAutoplay = video.dataset.deferredVideoAutoplay === "true";

			if (prefersReducedMotion() || !shouldAutoplay) {
				revealActiveControl();
				return;
			}

			playVideo(video, button);
		};

		videos.forEach((video) => {
			const button = video.parentElement.querySelector(
				"[data-deferred-video-play]",
			);
			button?.addEventListener("click", () => playVideo(video, button));
		});

		const priority = videos[0]?.dataset.deferredVideoPriority;
		if (priority === "high") {
			activate();
		} else if ("IntersectionObserver" in window) {
			const observer = new IntersectionObserver(
				(entries) => {
					if (!entries.some((entry) => entry.isIntersecting)) return;
					isNearViewport = true;
					observer.disconnect();
					activate();
				},
				{ rootMargin: "240px 0px" },
			);
			observer.observe(shell);
		} else {
			revealActiveControl();
		}

		window.addEventListener("resize", () => {
			if (priority === "high" || isNearViewport) activate();
			else revealActiveControl();
		});
	};

	const reveal = (section) => {
		section.classList.add("banner-with-text--animation-ready");
		section.classList.add("banner-with-text--in-view");
	};

	const initBannerAnimation = (section) => {
		if (!(section instanceof HTMLElement)) return;
		if (section.dataset.bannerAnimationInitialized === "true") return;

		section.dataset.bannerAnimationInitialized = "true";

		if (prefersReducedMotion() || !isDesktop()) {
			reveal(section);
			return;
		}

		section.classList.add("banner-with-text--animation-ready");

		if (!("IntersectionObserver" in window)) {
			reveal(section);
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				const isVisible = entries.some((entry) => entry.isIntersecting);
				if (!isVisible) return;

				section.classList.add("banner-with-text--in-view");
				observer.disconnect();
			},
			{
				rootMargin: "0px 0px -18% 0px",
				threshold: 0.2,
			},
		);

		observer.observe(section);
	};

	const initAll = (root = document) => {
		root
			.querySelectorAll(animationSelector)
			.forEach((section) => initBannerAnimation(section));
		root
			.querySelectorAll(videoSelector)
			.forEach((shell) => initBannerVideo(shell));
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => initAll());
	} else {
		initAll();
	}

	document.addEventListener("shopify:section:load", (event) => {
		if (!(event.target instanceof Element)) return;

		initAll(event.target);
		if (event.target.matches(animationSelector))
			initBannerAnimation(event.target);
		if (event.target.matches(videoSelector)) initBannerVideo(event.target);
	});
})();
